<div class="p-3" *ngIf="!isModifyDisabled" >
  <div class="row">
    <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
      <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="add()" type="button">Aggiungi</button>
    </div>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
    <thead>
      <tr>
        <th>Nome</th>
        <th scope="col">Ruolo</th>
        <th scope="col" *ngIf="!isModifyDisabled">Azioni</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of Employees">
        <td >
          <span *ngIf="!item.modifica" >
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="user" class="feather-sm"></i-feather>
            </span>
            {{ item.nome }}&nbsp;{{item.cognome}}
          </span>
          <span *ngIf="item.modifica">
            <input [(ngModel)]="item.nome" placeholder="nome" type="text" name="name" class="form-control">
            <input [(ngModel)]="item.cognome" placeholder="cognome" type="text" name="name" class="form-control">
          </span>
        </td>
        <td class="align-middle" >
          <span *ngIf="!item.modifica">
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-wrench"></i>
            </span>
            {{ item.ruolo}}
          </span>
          <span *ngIf="item.modifica">
            <input [(ngModel)]="item.ruolo" placeholder="role" type="text" name="role" class="form-control">
          </span>
        </td>
        <td class="align-middle" *ngIf="!isModifyDisabled" >
          <a *ngIf="!item.modifica"  href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
            (click)='edit(item)'>
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="Salva" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
            <i-feather name="check" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" ngbTooltip="Elimina"
            class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
